<template>
  <div class="position-relative w-100">
    <b-form-input
      ref="input_ref"
      :disabled="isDisabled"
      :state="state"
      v-model="query"
      :placeholder="locationId && items.length === 0 ? 'Создайте вакансию' : 'Выберите вакансию'"
      autocomplete="off"
      @focus="onFocusIn"
      @blur="onFocusOut"
      @click="isFocus = true"
    />

    <button type="button" class="custom-btn-select" :disabled="isDisabled" @mousedown.prevent="onClick">
      <v-icon v-if="query" name="buttons/cross" :size="11"/>
      <v-icon v-else-if="isFocus" name="buttons/collapse_chevrons_down" :size="10"/>
      <v-icon v-else name="buttons/collapse_chevrons_right" :size="10"/>
    </button>

    <div v-if="isFocus" class="custom-dropdown-select">
      <div class="custom-dropdown-list-scroll">
        <div
          v-for="item in filteredItems"
          :key="item.id"
          class="custom-dropdown-select-item"
          @mousedown.prevent="onSelect(item)"
        >
          <div class="text-small">{{ item.vacancy_name }}</div>
          <div class="text-secondary text-small">Количество: {{ item.workers_count }}</div>
        </div>
      </div>

      <div v-if="filteredItems.length > 0 && canEditLocationVacancies" class="custom-dropdown-select-footer p-1 border-top">
        <b-btn class="custom-btn-primary mt-0" :disabled="isDisabled" @mousedown.prevent="showRecruitLocationVacancy">
          <v-icon name="buttons/plus" :size="12"/>
          Добавить вакансию
        </b-btn>
      </div>

      <div v-if="filteredItems.length === 0 && query" class="empty-state-container p-2">
        <v-icon name="navbar/empty_table" :size="45"/>
        <small class="text-muted">Ничего не найдено</small>
        <b-btn v-if="canEditLocationVacancies" class="custom-btn-primary mt-2" :disabled="isDisabled" @mousedown.prevent="showRecruitLocationVacancy">
          <v-icon name="buttons/plus" :size="12"/>
          Добавить вакансию
        </b-btn>
      </div>
    </div>

    <RecruitLocationVacancy ref="recruit_location_vacancy" @refresh="getItems"/>
  </div>
</template>

<script>
import locationVacancies from "../../network/locationVacancies";
  import permissions, {PERM} from "../../utilites/permissions";
    import RecruitLocationVacancy from "../Recruiting/RecruitLocationVacancy.vue";

export default {
  name: "LocationVacancySelect",
  components: { RecruitLocationVacancy },
  mixins: [
    locationVacancies,
    permissions,
  ],
  props: {
    isDisabled: Boolean,
    locationId: Number,
    locationName: String,
    value: { type: Number, default: null },
    initialText: { type: String, default: '' },
    state: { type: Boolean, default: null }
  },
  data() {
    return {
      isFocus: false,
      query: "",
      items: [],
    }
  },
  computed: {
    filteredItems() {
      if (!this.query) return this.items;

      const lowerQuery = this.query.toLowerCase();

      if (this.value) {
        const selected = this.items.find(i => i.id === this.value);
        if (selected && selected.vacancy_name && selected.vacancy_name.toLowerCase() === lowerQuery) return this.items;
      }

      return this.items.filter(item =>
        item.vacancy_name.toLowerCase().includes(lowerQuery)
      );
    }
  },
  watch: {
    query: {
      handler(newValue) {
        if (newValue === "" && this.value !== 0) {
          this.$emit('onSelect', 0);
        }
      }
    },
    locationId: {
      async handler(newId, oldId) {
        if (newId !== oldId) {
          this.items = [];

          await this.getItems();

          if (oldId !== undefined) {
            this.onClear();
          }
        }
      }, immediate: true
    },
    initialText: {
      handler(newValue) {
        if (this.value && !this.query && newValue) {
          this.query = newValue;
        }
      }, immediate: true
    }
  },
  methods: {
    showRecruitLocationVacancy() {
      this.$refs.recruit_location_vacancy.showModal(null, false, this.locationId, this.locationName, true, true);
    },
    async getItems() {
      if (this.locationId) {
        const result = await this.getLocationVacancyByLocationId(this.locationId);
        this.items =  (result && result.data) ? result.data.items : [];
      } else {
        const data = {
          page: 1,
          size: 1000,
        };
        const result = await this.getLocationVacancies(data);
        this.items =  (result && result.data) ? result.data.items.filter(vacancy => vacancy.location_id === 0 || vacancy.location_id === null) : [];
      }
    },
    onFocusIn() {
      this.isFocus = true;
    },
    onFocusOut() {
      this.isFocus = false;

      if (!this.value && this.query) {
        this.query = "";
      }
    },
    onClick() {
      if (this.query) {
        this.onClear();
        this.$refs.input_ref.$el.focus();
      } else {
        this.onFocusIn();
        this.$refs.input_ref.$el.focus();
      }
    },
    onSelect(item) {
      this.query = item.vacancy_name;
      this.$emit('onSelect', item);
      this.onFocusOut();
    },
    onClear() {
      this.query = "";
      this.$emit('onSelect', 0);
    },
    // Permissions
    canEditLocationVacancies() {
      return this.hasPermission([PERM.LOCATION_VACANCY_EDIT]);
    },
  },
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Locations/LocationVacancySelect.vue